import { get } from 'lodash';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { FIRMWARE } from '../../../../../store/utils/files-names';

export const getModelsForBrandSelector = (state: AppRootState) =>
  get(state, FIRMWARE).models;
